import produce from 'immer'
import { assign, set } from 'lodash'

import { METADATA_TYPES } from '../../../common/constants'
import { buildTreeHierarchy, transformTree } from '../../../common/helpers'

import {
  ADD_ALLERGEN,
  DELETE_ALLERGEN,
  FETCH_ALLERGENS,
  RENAME_ALLERGEN,
  RESET_ALLERGEN_TREE,
  SAVE_ALLERGENS,
  SET_DATA_FOR_RENAMING_ALLERGEN,
  SET_IS_CURATION_ENABLED_ALLERGEN,
} from '../action-types'
import { ALLERGENS_INITIAL_STATE } from '../initial-states'

const allergensReducer = (state = ALLERGENS_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ALLERGENS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          initialData: [],
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_ALLERGENS.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } = action.payload.data.allergens
        const treeData = buildTreeHierarchy(results, METADATA_TYPES.ALLERGENS)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          latestEvent,
        })
      })

    case FETCH_ALLERGENS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
          initialData: [],
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_ALLERGENS.CLEANUP:
      return { ...ALLERGENS_INITIAL_STATE }

    case SAVE_ALLERGENS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          latestEvent: undefined,
        }),
      )

    case SAVE_ALLERGENS.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } = action.payload.data.saveAllergens

        const treeData = buildTreeHierarchy(results, METADATA_TYPES.ALLERGENS)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          isDirty: false,
          dataForRenaming: undefined,
          latestEvent,
        })
      })

    case SAVE_ALLERGENS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
          latestEvent: undefined,
        }),
      )

    case DELETE_ALLERGEN.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
        }),
      )

    case DELETE_ALLERGEN.COMPLETE:
      return produce(state, nextState => {
        const { results } = action.payload.data.deleteAllergen

        const treeData = buildTreeHierarchy(results, METADATA_TYPES.ALLERGENS)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          isDirty: false,
          dataForRenaming: undefined,
        })
      })

    case DELETE_ALLERGEN.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
        }),
      )

    case SET_IS_CURATION_ENABLED_ALLERGEN.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
        }),
      )

    case SET_IS_CURATION_ENABLED_ALLERGEN.COMPLETE:
      return produce(state, nextState => {
        const updatedAllergen = action.payload.data.setIsCurationEnabledAllergen

        const treeData = transformTree(nextState.initialData, node =>
          node.id === updatedAllergen.id
            ? {
                ...node,
                isCurationEnabled: updatedAllergen.isCurationEnabled,
              }
            : node,
        )

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          initialData: treeData,
          data: treeData,
          isDirty: false,
          dataForRenaming: undefined,
        })
      })

    case SET_IS_CURATION_ENABLED_ALLERGEN.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
        }),
      )

    case ADD_ALLERGEN:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: [...nextState.data, action.payload],
          isDirty: true,
          dataForRenaming: { id: action.payload.id },
        }),
      )

    case RENAME_ALLERGEN:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: set(
            nextState.data,
            `${action.payload.path}.name`,
            action.payload.name,
          ),
          isDirty: true,
        }),
      )

    case SET_DATA_FOR_RENAMING_ALLERGEN:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          dataForRenaming: action.payload,
        }),
      )

    case RESET_ALLERGEN_TREE:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: nextState.initialData,
          isDirty: false,
          dataForRenaming: undefined,
        }),
      )

    default:
      return state
  }
}

export default allergensReducer
